import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import VuexORM from '@vuex-orm/core';
import VuexORMAxios from '@vuex-orm/plugin-axios';

import auth from '@app2/modules/Auth/auth.store';
import addMedia from '@app2/modules/Library/Media/addMedia.store';
import canva from '@app2/modules/Library/Media/TranscriptEditor/mixins/canva.store'
import v2 from '@app2/store/2.0';
import filter from '@app2/modules/Audience/filter.store';
import pusher from '@app2/store/pusher.store';

import database from '@app2/store/database';
import {mediaQuery} from "@app2/utils/helpers";
import eventBus from '@app2/core/eventBus';

Vue.use(Vuex);

VuexORM.use(VuexORMAxios, {
  axios,
  baseURL: '/api/',
});

export default new Vuex.Store({
  state: {
    ongoingRequest: false,
    hasLoadedFirstRoute: false,
    shortcuts: [],
    isMobile: mediaQuery({
      maxWidth: 991
    }),
    isTablet: mediaQuery({
      maxWidth: 1200
    }),
    isMobileXs: mediaQuery({
      maxWidth: 576
    }),
    isMobile4: mediaQuery({
      maxWidth: 420
    }),
    isLaptop: mediaQuery({
      maxWidth: 1440
    }),
  },
  mutations: {
    setLoading(state, value) {
      state.ongoingRequest = value;
    },
    setLoadedFirstRoute(state, value) {
      state.hasLoadedFirstRoute = value;
    },
    setShortcuts(state, value) {
      state.shortcuts = value;
    },
    setIsMobile(state) {
      state.isMobile = mediaQuery({
        maxWidth: 991
      });
    },
    setIsTablet(state) {
      state.isTablet = mediaQuery({
        maxWidth: 1200
      });
    },
    setIsMobileXs(state) {
      state.isMobileXs = mediaQuery({
        maxWidth: 576
      });
    },
    setIsMobile4(state) {
      state.isMobile4 = mediaQuery({
        maxWidth: 420
      });
    },
    setIsLaptop(state) {
      state.isLaptop = mediaQuery({
        maxWidth: 1440
      });
    },
  },
  actions: {
    async fetchShortcuts({commit}) {
      try {
        const {data} = await axios.get('/api/internal/v2/hubs/shortcuts');
        commit('setShortcuts', data.data);
        eventBus.$emit('shortcutsFetched', data.data);
      } catch (e) {
        console.error(e);
      }
    },
  },
  modules: {
    auth,
    canva,
    v2,
    addMedia,
    filter,
    pusher
  },
  plugins: [
    VuexORM.install(database),
  ],
  getters: {
    isLaptop: state => state.isLaptop,
    isTablet: state => state.isTablet,
    isMobile: state => state.isMobile,
    isMobileXs: state => state.isMobileXs,
    isMobile4: state => state.isMobile4,
    shortcuts: (state, getters, rootState) => {
      let shortcuts = state.shortcuts;
      const fmlShortcut = shortcuts.find(shortcut => shortcut.title?.toLowerCase().includes('fml'));
      if ( fmlShortcut && !rootState?.auth?.user?.is_fml ) {
        shortcuts = shortcuts.filter(shortcut => shortcut.id !== fmlShortcut.id);
      }
      return shortcuts;
    }
  }
});
